// extracted by mini-css-extract-plugin
export default {"socialProof":"socialProof__OTIxN","dek":"dek__ZmJjZ","tooltipContainer":"tooltipContainer__YTA0Y","tooltipIcon":"tooltipIcon__YzgxN"};